export default {
  subListSubscriptionMap: {
    'management': {
      'tasks': 'task',
      'checklists': 'checklist',
      'changes': 'change',
      'licenses': 'license',
      'trainings': 'training',
      'events': 'event',
      'audits': 'audit',
      'contractors': 'contractor',
      'operations': 'contractor',
      'files': 'file',
      'pdf': 'pdf',
      'meeting': 'meeting',
      'guidelineAdmin': 'guideline',
      'qrcode': 'qrcode',
      'logs': 'log',
    },
  },
  getSubscriptionMap() {
    const subscriptionMap = this.subListSubscriptionMap;
    return {
      'overview': 'dashboard',
      'board': 'board',
      'alert': 'alert',
      'acts': 'act',
      'broadcasts': 'broadcast',
      'setting': null,
      'organization-dashboard': 'organization-dashboard-read',
      'factory-dashboard': 'factory-dashboard-read',
      'guideline': 'guideline',
      'announcement': 'announcement',
      'pdf': 'pdf',
      'meeting': 'meeting',
      ...subscriptionMap.management,
    };
  },
}